import * as actionType from "../constants/action_types";

const initialState = {
  activites: {
    data: [],
    current_page: 1,
    total_pages: null,
  },
};

const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GETACTIVITY_RESPONSE:
      return {
        ...state,
        activites: {
          data: action.payload.data
            ? [...state.activites.data, ...action.payload.data]
            : [...state.activites.data],
          current_page: action.payload.current_page || 1,
          total_pages:
            action.payload.data?.length === 0
              ? Math.ceil(state.activites.data?.length / action.payload.limit)
              : action.payload.total_pages || null,
        },
      };
    default:
      return state;
  }
};

export { activityReducer };
